import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/common/Logo';
import Sidebar from '../components/dashboard-patient/PatientSidebar';
import DoctorList from '../components/dashboard-patient/PatientDoctorList';

const PatientDashBoard = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleRepeatSurvey = () => {
        navigate('/survey');
    };

    return (
        <div className="flex min-h-screen">
            {/* Sidebar */}
            <div className="w-64 bg-white shadow-md">
                <div className="p-4">
                    <Logo />
                </div>
                <Sidebar />
            </div>

            {/* Main content area */}
            <div className="flex-1 p-8 bg-[#FAF4EB]">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold">Ecco i professionisti consigliati da noi</h1>
                </div>
                <header className="mb-6">

                </header>
                <DoctorList searchTerm={searchTerm} />
            </div>
        </div>
    );
};

export default PatientDashBoard;